<template>
  <v-container fluid tag="section">
    <validation-observer ref="observer" v-slot="{ invalid }">
      <base-material-card inline icon="mdi-poll" color="primary" class="ml-0 px-5 py-4">
        <template v-slot:after-heading>
          <div class="display-2 font-weight-light">
            {{ title }}
          </div>
        </template>
        <v-form class="pt-5">
          <parametros ref="parametrosREF" />
          <v-row>
            <v-col cols="12">
              <v-btn
                id="btn-save-indicador-prazo"
                color="success"
                min-width="100"
                style="float: right"
                class="mr-0 mt-5"
                :disabled="invalid"
                :loading="loading"
                @click="salvar()"
              >
                Salvar
              </v-btn>
            </v-col>
          </v-row>
        </v-form>
      </base-material-card>
    </validation-observer>
  </v-container>
</template>

<script>
  import IndicadorPrazosService from '@/services/IndicadorPrazosService';
  import dateFormatterMixins from '@/mixins/dateFormatterMixins';

  export default {
    components: {
      Parametros: () => import('@/components/indicadorPrazos/Parametros.vue')
    },
    mixins: [dateFormatterMixins],

    data: () => ({
      loading: false
    }),

    computed: {
      title() {
        return this.$route.params.id ? 'Editando Indicador de Prazos' : 'Adicionar Novo Indicador de Prazos';
      }
    },

    created() {
      this.$store.dispatch('clearIndicadorPrazos');

      if (this.$route.params.id) this.getById(this.$route.params.id);
    },

    methods: {
      getById(id) {
        IndicadorPrazosService.getById(id)
          .then((response) => {
            this.setDataInVuex(response.data.indicadorPrazo);
          })
          .catch(() => {
            this.$toast.error('Erro ao recuperar Indicador de Prazos.', '', {
              position: 'topRight'
            });
          });
      },

      salvar() {
        const id = this.$route.params.id ?? null;
        const data = this.$refs.parametrosREF.exportData();
        this.loading = true;

        IndicadorPrazosService.salvar(id, data)
          .then(() => {
            this.$toast.success('Indicador de Prazos salvo com sucesso.', '', {
              position: 'topRight'
            });
            this.$router.replace({ name: 'Indicador Prazos Histórico' });
          })
          .catch((err) => {
            console.error(err);
            this.$toast.error('Erro ao salvar Indicador de Prazos.', '', {
              position: 'topRight'
            });
          })
          .finally(() => (this.loading = false));
      },

      setDataInVuex(item) {
        this.$store.dispatch('setIndicadorPrazos', {
          titulo: item.titulo,
          obras: item.obras,
          saneamentoVoc: {
            id: item.calculos_com_ca_aneel.id,
            nome: item.calculos_com_ca_aneel.nome
          },
          dataImobilizacaoInicio: this.getOnlyDateIgnoringTimestamp(item.data_imobilizacao_inicio),
          dataImobilizacaoFim: this.getOnlyDateIgnoringTimestamp(item.data_imobilizacao_fim)
        });

        this.$forceUpdate();
      }
    }
  };
</script>
